import { EditImageModal } from './EditImageModal';

export default EditImageModal;
